// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 引入iconfont图标
import "@/assets/icon/iconfont.css"
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import './permission'

import api from './api'
Vue.prototype.$api = api;

import Utils from './common/utils'
Vue.prototype.Utils = Utils

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

import Print from 'vue-print-nb';
Vue.use(Print)

import store from './store'
// main.js
import 'katex/dist/katex.min.css'
import * as katex from 'katex'
window.katex = katex
/* eslint-disable no-new */
new Vue({
  el: '#app',
  beforeCreate(){
    Vue.prototype.$bus=this
  },
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js